import { render, staticRenderFns } from "./workingdays.vue?vue&type=template&id=36edf982&scoped=true&v-if=this.user.loggedIn"
import script from "./workingdays.vue?vue&type=script&lang=js"
export * from "./workingdays.vue?vue&type=script&lang=js"
import style0 from "./workingdays.vue?vue&type=style&index=0&id=36edf982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36edf982",
  null
  
)

export default component.exports